<template>

<div class="wrapper">

	<com-mobile v-if="$isMobile" v-on:context="is.panel = true" />

	<com-menu v-if="!$route.meta.isStandalone && !$route.meta.isHome" :show="is.panel" v-on:close="is.panel = false" v-on:open="is.panel = true" />
	<com-panel v-if="!$route.meta.isStandalone && !$route.meta.isHome" :show="is.panel" v-on:close="is.panel = false" />

	<com-content>

		<slot></slot>

	</com-content>

</div>

</template>

<script>

import comMobile from './../page/Mobile'
import comMenu from './../page/Menu'
import comPanel from './../page/Panel'
import comContent from './../page/Content'

export default {
	
	props: ['centralise', 'loading', 'background'],

	data: function() {

		return {
			is: {
				panel: false
			}
		}

	},
	
	components: {
		comMenu,
		comMobile,
		'com-panel': comPanel,
		'com-content': comContent
	},

	watch: {

		$path: function() {

			this.is.panel = false

		}

	}

}

</script>

<style scoped>

</style>
